const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const sensorAnalysisApi = {
  async createRequest({ projectId, token, name, configurations }) {
    const response = await fetch(`${API_BASE_URL}/sensor-analysis/requests`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        projectId,
        name,
        configurations,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },


};
